import { useState } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Select,
  InputNumber,
  Row,
  Col,
} from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import useDeliveryStore from "../../store/DeliveryStore";

const { Option } = Select;
const { TextArea } = Input;

const ManualBooking = ({ orderId, onSuccess }) => {
  const { loading, setLoading } = useDeliveryStore();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleSubmit = async (values) => {
    setLoading(true);

    try {
      // Format the data
      const initiatorDetails = {
        task_id: values.taskId,
        tracking_link: values.trackingLink,
        initiator: values.initiator,
        delivery_cost: values.deliveryCost,
      };

      await onSuccess(JSON.stringify(initiatorDetails));
    } catch (error) {
    } finally {
      // Close modal and reset form
      handleCancel();

      setLoading(false);
    }
  };

  return (
    <>
      <Button
        type="primary"
        className="manual-btn"
        icon={<ClockCircleOutlined />}
        onClick={showModal}
        style={{ width: "100%" }}
      >
        Manual Booking
      </Button>

      <Modal
        title={`Create Manual Booking for ${orderId}`}
        visible={isModalVisible}
        onCancel={handleCancel}
        width={700}
        footer={[
          <Button key="cancel" onClick={handleCancel} disabled={loading}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            className="manual-btn"
            loading={loading}
            onClick={() => form.submit()}
          >
            Create Booking
          </Button>,
        ]}
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          requiredMark="optional"
        >
          <Row gutter={16}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="Task Id"
                name="taskId"
                rules={[
                  {
                    required: true,
                    message: "Please enter manual delivery task id",
                  },
                  { min: 2, message: "Task Id too short" },
                ]}
              >
                <Input placeholder="CRN1770591237" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24}>
              <Form.Item
                label="Tracking Link"
                name="trackingLink"
                rules={[
                  { required: true, message: "Please enter the tracking link" },
                ]}
              >
                <TextArea rows={3} placeholder="Full tracking link" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="Booked By"
                name="initiator"
                rules={[
                  {
                    required: true,
                    message: "Please select who is creating the manual booking",
                  },
                ]}
              >
                <Select placeholder="Select initiator">
                  <Option value="nikhil">Nikhil</Option>
                  <Option value="yashi">Yashi</Option>
                  <Option value="anushree">Anushree</Option>
                  <Option value="akash">Akash</Option>
                  <Option value="ashish">Ashish</Option>
                  <Option value="sarthak">Sarthak</Option>
                  <Option value="harriet">Harriet</Option>
                  <Option value="aditi">Aditi</Option>
                  <Option value="arunima">Arunima</Option>
                  <Option value="priyanka">Priyanka</Option>
                  <Option value="sanjay">Sanjay</Option>
                  <Option value="gaurav">Gaurav</Option>
                  <Option value="parikshit">Parikshit</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="Delivery Cost (₹)"
                name="deliveryCost"
                rules={[
                  {
                    type: "number",
                    min: 0,
                    required: true,
                    message: "Invalid value",
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="0"
                  min={0}
                  formatter={(value) =>
                    `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default ManualBooking;
